import { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider, createTheme, Spinner } from '@fluentui/react'
import { MsalAuthenticationTemplate } from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'
import Layout from './components/Layout'
import './App.css'

// Lazy load page components for better code splitting
const Dashboard = lazy(() => import('./pages/Dashboard'))
const FileManager = lazy(() => import('./pages/FileManager'))
const Settings = lazy(() => import('./pages/Settings'))

const theme = createTheme({
  palette: {
    themePrimary: '#0078d4',
    themeLighterAlt: '#f3f8fc',
    themeLighter: '#d0e7f8',
    themeLight: '#a9d3f2',
    themeTertiary: '#5ca7e5',
    themeSecondary: '#1890d9',
    themeDarkAlt: '#106ebe',
    themeDark: '#0e5ca8',
    themeDarker: '#0a4480',
    neutralLighterAlt: '#fafafa',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#a6a6a6',
    neutralSecondary: '#666666',
    neutralPrimaryAlt: '#3c3c3c',
    neutralPrimary: '#323130',
    neutralDark: '#212121',
    black: '#000000',
    white: '#ffffff',
  },
  fonts: {
    small: {
      fontSize: '12px',
      fontWeight: '400',
    },
    medium: {
      fontSize: '14px',
      fontWeight: '400',
    },
    mediumPlus: {
      fontSize: '16px',
      fontWeight: '400',
    },
    large: {
      fontSize: '18px',
      fontWeight: '600',
    },
    xLarge: {
      fontSize: '20px',
      fontWeight: '600',
    },
    xxLarge: {
      fontSize: '28px',
      fontWeight: '700',
    },
  },
})

const loginRequest = {
  scopes: ['User.Read', `api://${import.meta.env.VITE_AZURE_CLIENT_ID || '14d7b2b8-459b-452b-b413-452e691b6e74'}/access_as_user`],
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <MsalAuthenticationTemplate 
        interactionType={InteractionType.Redirect} 
        authenticationRequest={loginRequest}
      >
        <Router>
          <Layout>
            <Suspense fallback={<Spinner size={3} label="Loading..." />}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/files/*" element={<FileManager />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Suspense>
          </Layout>
        </Router>
      </MsalAuthenticationTemplate>
    </ThemeProvider>
  )
}

export default App
